/**
 * ============================================================
 * PORTAL LIFE
 * ============================================================
 */
const Life = {
    config: {
       /* apiUrl: "https://n8n.rhfranquias.com.br/webhook-test/504cb224-0fb1-4a40-8f9b-c2f03104e253" */
        apiUrl: "https://webhook.rhfranquias.com.br/webhook/504cb224-0fb1-4a40-8f9b-c2f03104e253" 
    },
    init() {
        console.log("Portal Life iniciado.");
        this.form = document.getElementById("lifeLoginForm");
        this.cpf = document.getElementById("lifeCpf");
        this.msg = document.getElementById("lifeMessage");
        if (!this.form || !this.cpf || !this.msg) {
            // Formulário Life não presente nesta página (ex: coleções, produto) — comportamento esperado
            return;
        }

        this.cpf.addEventListener("input", this.maskCPF);

        this.form.addEventListener("submit", (e) => {
            this.login(e);
        });

    },

    /**
     * Máscara CPF
     */
    maskCPF(e) {

        let value = e.target.value;

        value = value.replace(/\D/g, '');
        value = value.replace(/(\d{3})(\d)/, '$1.$2');
        value = value.replace(/(\d{3})(\d)/, '$1.$2');
        value = value.replace(/(\d{3})(\d{1,2})$/, '$1-$2');

        e.target.value = value;

    },

    /**
     * Login
     */
    async login(e) {

        e.preventDefault();

        const cpf = this.cpf.value.replace(/\D/g, '');

        if (cpf.length !== 11) {

            this.showMessage("Informe um CPF válido.", "red");
            return;

        }

        this.showMessage("Consultando benefício...", "#555");

        console.log("CPF enviado:", cpf);

        try {

            const response = await fetch(this.config.apiUrl, {

                method: "POST",

                headers: {
                    "Content-Type": "application/json"
                },

                body: JSON.stringify({
                    cpf: cpf
                })

            });

            console.log("Status:", response.status);

            const data = await response.json();

            console.log("data completo:", JSON.stringify(data));
            console.log("data.success:", data.success);
            console.log("data.session:", data.session);
            console.log("typeof data.success:", typeof data.success);

            console.log("Resposta do N8N:", data);

            if (!response.ok) {

                this.showMessage("Erro ao consultar benefício.", "red");
                return;

            }

           if (data.success) {

              // Salva a sessão no cookie
               this.setCookie("portal_session", data.session, 8);
              localStorage.setItem("life_session", JSON.stringify(data));

             // Salva a sessão nos cart attributes
              await fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
            attributes: {
               // 'life_session': data.session
               'life_session': JSON.stringify(data)
            }
        })
    });

          // Mensagem ao usuário
         this.showMessage("Verificação concluída. Redirecionando...", "green");

         // Aguarda 1 segundo e redireciona
        setTimeout(() => {
        window.location.href = "/collections/oculos-de-grau-1";
    }, 1000);

} else {

    this.showMessage(data.message || "Cliente não elegível.", "red");

}

        } catch (error) {

            console.error(error);

            this.showMessage("Erro ao conectar ao servidor.", "red");

        }

    },

    /**
     * Mensagens
     */
    showMessage(message, color) {

        this.msg.style.color = color;
        this.msg.innerHTML = message;

    },

    /**
     * Cookie
     */
    setCookie(name, value, hours) {

        const date = new Date();

        date.setTime(date.getTime() + (hours * 60 * 60 * 1000));

        document.cookie =
            `${name}=${value}; expires=${date.toUTCString()}; path=/`;

    },

    /**
     * Ler Cookie
     */
    getCookie(name) {

        const cookieName = name + "=";

        const cookies = document.cookie.split(";");

        for (let cookie of cookies) {

            cookie = cookie.trim();

            if (cookie.indexOf(cookieName) === 0) {

                return cookie.substring(cookieName.length);

            }

        }

        return "";

    },

    /**
     * Desconto Life por tag de produto
     */
    getSession() {
        try {
            return JSON.parse(localStorage.getItem("life_session"));
        } catch {
            return null;
        }
    },

    async applyDiscount() {

    const session = this.getSession();
    if (!session?.regras?.desconto) return;

    // Aguarda window.lifeProductTags estar disponível
    const waitForTags = () => new Promise(resolve => {
        if (window.lifeProductTags !== undefined) return resolve(window.lifeProductTags);
        const interval = setInterval(() => {
            if (window.lifeProductTags !== undefined) {
                clearInterval(interval);
                resolve(window.lifeProductTags);
            }
        }, 100);
        setTimeout(() => { clearInterval(interval); resolve([]); }, 5000);
    });

    const rawTags = await waitForTags();
    const tags = rawTags.map(t => t.toLowerCase());
    if (!tags.length) return;

    const lifeTags = (session.regras.tags || ['life']).map(t => t.toLowerCase());
    if (!tags.some(t => lifeTags.includes(t))) return;

    // Badge
    const showBadge = () => {
        const badge = document.getElementById('life-discount-badge');
        const msg = document.querySelector('.life-benefit-msg');
        if (!badge || !msg) return false;
        msg.textContent = `🎁 ${session.cliente?.nome}, seu benefício Life está ativo — ${session.regras.desconto}% de desconto neste item`;
        badge.classList.remove('life-discount-badge--hidden');
        return badge.offsetHeight > 0;
    };

    if (!showBadge()) {
        const interval = setInterval(() => {
            if (showBadge()) clearInterval(interval);
        }, 300);
        setTimeout(() => clearInterval(interval), 10000);
    }

    // Aplica discount code no carrinho via /discount/CODE
    const code = session.discount_code || '';
    if (!code) return;

    fetch(`/discount/${code}`, { method: 'GET', redirect: 'follow' })
        .then(() => console.log(`[Life] Discount ${code} aplicado ao carrinho`))
        .catch(err => console.warn('[Life] Erro ao aplicar discount:', err));

    // Monitora cliques em links de checkout
    document.addEventListener('click', (e) => {
        const btn = e.target.closest('a[href*="/checkout"], a[href*="/cart"]');
        if (!btn) return;
        const href = btn.getAttribute('href');
        if (href && href.includes('/checkout')) {
            e.preventDefault();
            window.location.href = `/checkout?discount=${code}`;
        }
    }, true);

},
    /**
     * Logout
     */
    
      logout() {
        document.cookie = "portal_session=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
        window.location.href = "/collections/oculos-de-grau-1";
    }

};

/**
 * Inicialização
 */
window.Life = Life;

/**
 * Fix: re-anima cards após filtro do Search & Discovery
 */
document.addEventListener('DOMContentLoaded', () => {
  const fixCards = () => {
    document.querySelectorAll('li.predictive-search-results__card').forEach(el => {
      el.style.opacity = '1';
      el.style.transition = 'opacity 0.3s ease';
    });
  };

  // Observa o body inteiro para garantir que pega qualquer mudança
  const observer = new MutationObserver(fixCards);
  observer.observe(document.body, { childList: true, subtree: true });

  // Também roda em popstate (navegação por URL do filtro)
  window.addEventListener('popstate', () => setTimeout(fixCards, 300));

  // Roda ao carregar também
  fixCards();
});
document.addEventListener("DOMContentLoaded", () => {
    Life.init();
    Life.applyDiscount();
});






